import React from "react"
import envHelper from "@digits-shared/helpers/envHelper"
import useSession from "@digits-shared/hooks/useSession"
import { AspectCode } from "@digits-shared/session/AspectCode"
import type FrontendSession from "src/frontend/session"

// Has permissions to use the match buttons if:
// 1. User does not have the RestrictLedgerEdits aspect
// 2. User is not in production
export const useHasMatchButtonsPermissions = () => {
  const { hasAccessToAspect } = useSession<FrontendSession>()

  return React.useMemo(
    () => !hasAccessToAspect(AspectCode.RestrictLedgerEdits) || !envHelper.isProduction(),
    [hasAccessToAspect]
  )
}
